import styled from "styled-components";

import { colors } from "~/styles";

export const BoxSection = styled.div`
  background: ${colors.white_label};
`;
